/**
 * Poniższe metody są uproszczoną wersją UI.HTML.Template
 */

export function propertyTraverser(path: string) {
  const steps = path.split('.');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return object => steps.reduce((obj, key) => obj && key in obj ? obj[key] : '', object);
}

// Pobierz wartość właściwości na podstawie tokenu
export function getter(token: string) {
  const isOptional = token.endsWith("?%");
  const getValue = propertyTraverser(token.replace(/%|\?/g, ''));
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return data => {
    const value = getValue(data);
    if (value != null) {
      return value;
    }
    if (isOptional) {
      return '';
    }
  };
}

// // Generuj funkcję szablonu
// export function createTemplate(template: string) {
//   const tokens = (template.match(/%.+?(\?)?%/gi) || []).reduce((obj, token) => {
//     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//     // @ts-ignore
//     obj[token] = getter(token);
//     return obj;
//   }, {});
//
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   // @ts-ignore
//   return data => Object.keys(tokens).reduce((str, token) => {
//     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//     // @ts-ignore
//     return str.replace(new RegExp(token, 'g'), tokens[token](data));
//   }, template);
// }
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function replaceConditionMacros(generatedHtml, mainProduct) {
  
  // Obsługa instrukcji warunkowej if/else
  const ifRegex = /{{#if (\w+)\s*(===|!==|==|!=|>|>=|<|<=)?\s*(['"]?[\w\s]+['"]?)?}}([\s\S]+?){{\/if}}/g;
  
  let newHtml = generatedHtml;
  const matches = Array.from(newHtml.matchAll(ifRegex));
  
  matches.forEach(match => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
    const [fullMatch, ifVariable, operator, compareValue, fullIfContent] = match;
    
    // Rozdzielamy zawartość na sekcje if i else
    const splitContent = fullIfContent.split('{{else}}');
    const ifContent = splitContent[0];
    const elseContent = splitContent[1] || '';
    
    let ifResult = '';
    
    // Usuwamy cudzysłowy jeśli są obecne
    const cleanedCompareValue = compareValue ? compareValue.replace(/['"]/g, '') : null;
    
    let conditionMet = false;
    
    switch (operator) {
      case '===':
        conditionMet = mainProduct[ifVariable] === cleanedCompareValue;
        break;
      case '!==':
        conditionMet = mainProduct[ifVariable] !== cleanedCompareValue;
        break;
      case '==':
        conditionMet = mainProduct[ifVariable] == cleanedCompareValue;
        break;
      case '!=':
        conditionMet = mainProduct[ifVariable] != cleanedCompareValue;
        break;
      case '>':
        conditionMet = mainProduct[ifVariable] > cleanedCompareValue;
        break;
      case '>=':
        conditionMet = mainProduct[ifVariable] >= cleanedCompareValue;
        break;
      case '<':
        conditionMet = mainProduct[ifVariable] < cleanedCompareValue;
        break;
      case '<=':
        conditionMet = mainProduct[ifVariable] <= cleanedCompareValue;
        break;
      default:
        conditionMet = Boolean(mainProduct[ifVariable]);
    }
    
    ifResult = conditionMet ? ifContent : elseContent;
    
    newHtml = newHtml.replace(fullMatch, ifResult);
  });
  
  return newHtml;
}



// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function replaceLoopMacros(generatedHtml, productVariants) {
  const loopRegex = /{{#each (\w+)}}([\s\S]+?){{\/each}}/g;
  let match;
  
  while ((match = loopRegex.exec(generatedHtml)) !== null) {
    const [fullMatch, loopVariable, loopContent] = match;
    let loopResult = '';
    
    if (loopVariable === 'variant') {
      const showRegex = /{{#show (\d+) elements}}([\s\S]+?){{showRest}}([\s\S]+?){{\/show}}/g;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, showLimit, firstPart, secondPart] = showRegex.exec(loopContent) || [];
      let addedSecondPart = false;
      
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      productVariants.forEach((variant, index) => {
        let loopItem = loopContent;
        
        // Zastępujemy każdą właściwość wariantu
        for (const variantProperty in variant) {
          const regex = new RegExp(`{{${variantProperty}}}`, 'g');
          loopItem = loopItem.replace(regex, variant[variantProperty] || '');
        }
        
        // Obsługa warunków if-else z indeksem
        if (index < showLimit) {
          loopItem = loopItem.replace(showRegex, firstPart);
        } else if (!addedSecondPart) {
          loopItem = loopItem.replace(showRegex, secondPart);
          addedSecondPart = true;
        } else {
          loopItem = '';
        }
        
        loopResult += loopItem;
      });
    }
    
    generatedHtml = generatedHtml.replace(fullMatch, loopResult);
  }
  return generatedHtml;
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
function replaceMainMacros(generatedHtml, mainProduct) {
  for (const [key, value] of Object.entries(mainProduct)) {
    const regex = new RegExp(`{{${key}}}`, 'g');
    generatedHtml = generatedHtml.replace(regex, value || '');
  }
  
  return generatedHtml
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export function createTemplate(templateString, mainProduct, productVariants) {
  let generatedHtml = templateString;
  
  generatedHtml = replaceConditionMacros(generatedHtml, mainProduct,)
  generatedHtml = replaceLoopMacros(generatedHtml, productVariants)
  generatedHtml = replaceMainMacros(generatedHtml, mainProduct)
  
  return generatedHtml;
}


/**
 * Przykłady użycia
 * {{#if someVariable}}
 *   <p>Zmienna someVariable istnieje!</p>
 * {{/if}}
 *
 *
 * {{#if someVariable}}
 *   <p>Zmienna someVariable istnieje!</p>
 *   {{else}}
 *   <p>Zmienna someVariable nie istnieje!</p>
 * {{/if}}
 *
 *
 */


